import { PropsWithChildren, HTMLAttributes } from 'react';

import { usePageContainerHeight } from '@/hooks/usePageContainerHeight';
import { ValuesOf } from '@/types';
import { cn } from '@/utils';

const containerVariants = {
  fluid: 'fluid',
  default: 'default',
  default1: 'default-1',
} as const;

type Props = HTMLAttributes<HTMLDivElement> &
  PropsWithChildren<{
    variant: ValuesOf<typeof containerVariants>;
  }>;

const Container = ({ variant, children, className, ...rest }: Props) => {
  const { containerHeight } = usePageContainerHeight();

  const containerClassName = cn('w-full mx-auto', className, {
    'max-w-[1200px]': variant === containerVariants.default,
    'max-w-[1100px]': variant === containerVariants.default1,
    'max-w-[1366px]': variant === containerVariants.fluid,
  });

  return (
    <main
      className={containerClassName}
      {...rest}
      style={{ minHeight: containerHeight }}
    >
      {children}
    </main>
  );
};

export default Container;
